import Button from '../ui/Button';

import {useState} from 'react'
import {cenas} from '../../dados/quadrinhos'

import './Quadrinhos.css'
export default function Quadrinhos ({setShowModal}){
    const [cont, setCont] = useState(0)

    const avancar = () => {
        if (cont < 5) {
            setCont(prev => prev + 1);
        } else {
            setShowModal(true);
        }
    };


    return(
        <div className="quadrinhos">
            
            <div className="cena">
                <img src={cenas[cont].cena} />
            </div>
            <div className='passarCena'>
                <Button 
                    className='btnTransparent'
                    onClick={() => setCont(prev => prev > 0 ? prev - 1 : 0)}
                    text="Voltar"
                />
                <Button 
                    className="btnAzul"
                    onClick={()=> avancar()}
                    text="Seguir"
                />
            </div>
        </div>
    )
}